export function Unauthorized() {
    return <h1>Unauthorized</h1>;
}
